/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Calendar_View_DaysInputs */

const en_calendar_view_days = /** @type {(inputs: Calendar_View_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} days`)
};

const pt_br2_calendar_view_days = /** @type {(inputs: Calendar_View_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dias`)
};

/**
* | output |
* | --- |
* | "{count} days" |
*
* @param {Calendar_View_DaysInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_view_days = /** @type {((inputs: Calendar_View_DaysInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_View_DaysInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_view_days(inputs)
	return pt_br2_calendar_view_days(inputs)
});